import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container, Reveal } from "@/components/Reveal";
import ServiceIcon from "@/components/ServiceIcon";
import { SERVICES } from "@/data/content";

export default function CoreServices() {
  return (
    <section id="services" className="bg-white py-24 md:py-32">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="overline text-electric">Our Services</p>
            <h2 className="mt-4 font-heading text-3xl font-semibold tracking-tight text-navy sm:text-4xl lg:text-5xl">
              Energy solutions we broker for your business.
            </h2>
          </div>
          <Link
            to="/solutions"
            className="group inline-flex items-center gap-2 text-sm font-medium text-navy"
          >
            All solutions
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 border-t border-l border-line md:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.1} className="border-b border-r border-line">
              <Link
                to={`/solutions/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group relative flex h-full flex-col overflow-hidden p-8 md:p-10"
              >
                <div
                  className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                  style={{ backgroundImage: `url(${s.image})` }}
                />
                <div className="pointer-events-none absolute inset-0 bg-navy/0 transition-colors duration-500 group-hover:bg-navy/90" />

                <div className="relative z-10 flex h-full flex-col">
                  <div className="flex items-center justify-between">
                    <div
                      className="flex h-14 w-14 items-center justify-center border border-line text-electric transition-colors duration-500 group-hover:border-white/30 group-hover:text-energy"
                    >
                      <ServiceIcon name={s.icon} className="h-7 w-7" />
                    </div>
                    <span className="font-mono text-xs text-slatey transition-colors group-hover:text-white/50">
                      0{i + 1}
                    </span>
                  </div>

                  <h3 className="mt-8 font-heading text-2xl font-medium text-navy transition-colors duration-500 group-hover:text-white">
                    {s.title}
                  </h3>
                  <p className="mt-3 flex-1 text-[15px] leading-relaxed text-slatey transition-colors duration-500 group-hover:text-white/75">
                    {s.short}
                  </p>

                  <span className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-electric transition-colors duration-500 group-hover:text-white">
                    Learn More
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
